<div nz-row>
  <div nz-col nzSpan="24">
    <iframe id="frm_Viewprf"  [src]="path | safe : 'resourceUrl'" style="width: 100%; height: 75vh !important"> </iframe>
  </div>
  <div *nzModalHeader>

    meoewwww
</div>
</div>
